export default function () {
  if (document.getElementById('selection-item-app')) {
    // eslint-disable-next-line no-unused-expressions
    import(
      /* webpackChunkName: "selection-item-app" */ '@organisms/offer/proposal/main'
    );
  }
}
